import React, { useContext } from 'react';
import { ContextToggle } from '../context/ContextToggle';
import './ModernNavButton.css';

const ModernNavButton = () => {
  const { handleShow } = useContext(ContextToggle);

  return (
    <button 
      className="modern-nav-button" 
      onClick={handleShow}
      aria-label="Abrir menú de navegación"
    >
      <div className="hamburger">
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </div>
    </button>
  );
};

export default ModernNavButton;
